import APIError from './APIError';

export default class InvalidRequestError extends APIError {
  static HTTP_CODES = [400];

  static ERROR_CODES = {
    INVALID_REQUEST: 'invalidRequest',
    INVALID_SLOT_SELECTED: 'invalidSlotSelected',
    INVALID_TOKEN: 'invalidToken',
    PASSWORD_BROKEN: 'passwordBroken',
    MINOR_ENROLLMENTS_NOT_ALLOWED: 'minorNotAllowed',
  };

  static ERROR_TYPES = {
    default: 'generic',
    enum: 'generic',
    required: 'required',
    format: 'generic',
    minimum: 'minLimit',
    maximum: 'maxLimit',
    validatePhone: 'validatePhone',
  };

  constructor(error) {
    super({ name: 'InvalidRequestError', message: 'This request contains invalid data' });

    this.response = undefined;
    this.status = undefined;
    this.code = undefined;
    this.reason = undefined;
    this.errors = undefined;
    this.parsePayload(error);
  }

  parsePayload(error) {
    const errorResponse = error?.response;
    const errorData = errorResponse?.data;

    this.response = errorResponse;
    this.status = errorResponse?.status;
    this.code = InvalidRequestError.ERROR_CODES[errorData?.code] || errorData?.code;
    this.reason = errorData?.reason;
    this.errors = InvalidRequestError.parseFieldErrors(errorData?.errors);
  }

  static parseFieldErrors(errors = []) {
    // error.instancePath -> field/object with error
    // error.keyword -> error type (required, format,...),
    // error.params -> error details ({"missingProperty": "first_name"})

    if (!errors?.length) {
      return null;
    }

    const validErrors = errors.filter(e => e.instancePath);
    if (!validErrors?.length) {
      return null;
    }

    const parsedErrors = validErrors.reduce((acc, error) => {
      const apiErrorField = error.instancePath.replace('/', ''); // remove the first / from the path
      const apiErrorType = error?.keyword || '';

      acc[apiErrorField] = {
        type: InvalidRequestError.mapAPIErrorType(apiErrorType),
        params: error.params || {},
      };

      return acc;
    }, {});
    return parsedErrors;
  }

  static mapAPIErrorType(apiErrorType) {
    const errorMap = InvalidRequestError.ERROR_TYPES;
    return errorMap[apiErrorType] || errorMap.default;
  }

  static matchesFormat(error) {
    const errorStatus = error?.response?.status;
    const errorCode = error?.response?.data?.code;
    if (!errorStatus) return false;

    const hasInvalidRequestStatus = InvalidRequestError.HTTP_CODES.includes(errorStatus);
    const hasInvalidRequestCode = errorCode in InvalidRequestError.ERROR_CODES;
    return hasInvalidRequestStatus && hasInvalidRequestCode;
  }
}
